import { defineMessages } from 'react-intl';
import { columnsMessages } from '../../../../customization-messages';

const localMessages = defineMessages({
  labelColumn: {
    id: 'Column',
    defaultMessage: 'Column',
  },
  labelDefault: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  labelColumnTitle: {
    id: 'Column title',
    defaultMessage: 'Column title',
  },
  labelColumnsBlock: {
    id: 'Columns block',
    defaultMessage: 'Columns block',
  },
  labelTitle: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  descrTitle: {
    id: 'Columns block friendly name',
    defaultMessage: 'Columns block friendly name',
  },
  labelColumns: {
    id: 'Columns',
    defaultMessage: 'Columns',
  },
  labelLayout: {
    id: 'Layout',
    defaultMessage: 'Layout',
  },
  labelReverseWrap: {
    id: 'Reverse wrap',
    defaultMessage: 'Reverse wrap',
  },
  reverseWrapDescription: {
    id: 'reverseWrapDescription',
    defaultMessage: 'Reverse column order when opening site on mobile.',
  },
});

const messages = { ...localMessages, ...columnsMessages };

const colors = (intl) => [
  {
    name: 'transparent',
    label: intl.formatMessage(messages.transparent),
  },
  {
    name: 'gray',
    label: intl.formatMessage(messages.gray),
  },
];

export const ColumnSchema = (intl) => ({
  title: intl.formatMessage(messages.labelColumn),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.labelDefault),
      fields: ['column_title'],
    },
  ],
  properties: {
    column_title: {
      title: intl.formatMessage(messages.labelColumnTitle),
    },
  },
  required: [],
});

export const ColumnsBlockSchema = (intl) => ({
  title: intl.formatMessage(messages.labelColumnsBlock),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.labelDefault),
      fields: [
        'title',
        'data',
        'gridCols',
        'fullWidth',
        'backgroundColor',
        'increasePadding',
        'reverseWrap',
      ],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.labelTitle),
      description: intl.formatMessage(messages.descrTitle),
      type: 'string',
    },
    data: {
      title: intl.formatMessage(messages.labelColumns),
      type: 'columns',
      schema: ColumnSchema(intl),
      maxSize: 6,
    },
    gridCols: {
      title: intl.formatMessage(messages.labelLayout),
      widget: 'layout_select',
      choices: [],
    },
    reverseWrap: {
      title: intl.formatMessage(messages.labelReverseWrap),
      description: intl.formatMessage(messages.reverseWrapDescription),
      type: 'boolean',
    },
    backgroundColor: {
      title: intl.formatMessage(messages.backgroundColor),
      default: 'transparent',
      widget: 'color_picker',
      colors: colors(intl),
    },
    increasePadding: {
      title: intl.formatMessage(columnsMessages.increasePadding),
      type: 'boolean',
    },
    fullWidth: {
      title: intl.formatMessage(columnsMessages.fullWidth),
      required: true,
      noValueOption: false,
      default: 'none',
      type: 'string',
      factory: 'Choice',
      choices: [
        ['none', intl.formatMessage(columnsMessages.none)],
        ['background', intl.formatMessage(columnsMessages.background)],
        ['all', intl.formatMessage(columnsMessages.contentAndBackground)],
      ],
    },
  },
  required: [],
});
